import { BoxProps } from '@kite-js/core/lib/Box/Box';
import * as React from 'react';
import { NotificationCenterContext, Notification } from './NotificationContext';

export type NotificationContainer =
    | 'ChangePassword'
    | 'ForgotPasswordEmail'
    | 'ForgotPasswordPhone'
    | 'Login'
    | 'SocialLogin'
    | 'Signup'
    | 'PhoneAssociation'
    | 'SubmitOtp'
    | 'OtpLogin'
    | 'VerifyOtp'
    | 'AuthedPhoneAssociation'
    | 'UnifiedAuth'
    | 'UnifiedSocialLoginForm'
    | 'ForceLogout'
    | 'ResetPin'
    | 'WalletAuth'
    | 'WalletSca'
    | 'WhatsAppForm';

export const usePushNotification = (container: NotificationContainer) => {
    const { pushNotification } = React.useContext(NotificationCenterContext);
    return (notification: Omit<Notification, 'container'>) => pushNotification({ ...notification, container });
};

export const useRenderNotification = (container: NotificationContainer) => {
    const { renderNotification } = React.useContext(NotificationCenterContext);
    return (wrapperProps?: BoxProps | undefined) => renderNotification(container, wrapperProps);
};

export const useResetNotification = () => {
    const { resetNotification } = React.useContext(NotificationCenterContext);
    return resetNotification;
};
